<template>
	<div class="main-c-div" v-loading="loading">
		<div class="account-info-div">
			<span style="font-size:20px;font-weight: bolder;">
				{{$t('vip.credit.balance')}}:
				<font color="#409EFF" size="5">{{ loginUser.account.balance }} </font>
				<font color="#409EFF" size="2">{{$t('vip.credit.name')}}</font>
			</span>
		</div>
		<div class="recharge-project-div">
			<div class="project-left-div">
				<!-- <i class="fa fa-truck" aria-hidden="true"></i> -->
				{{$t('vip.payment.items')}}:
			</div>
			<div class="project-right-div">
				<el-row :gutter="20">
					<el-col :span="6" v-for="(item,index) in rechargeNums" :key="index">
						<div :class="'option-box ' + (rechargeNum==item ? 'option-box-checked' : '')" @click="rechargeNum=item">
							<div class="matter-span">
								{{ item }} {{$t('app.week')}}
							</div>
							<span>{{ item * 20 }} {{$t('vip.credit.name')}}</span>
							<div v-if="rechargeNum==item" class="corner-mark-div"></div>
						</div>
					</el-col>
					<el-col :span="12">
						<div :class="'option-box ' + (rechargeNums.indexOf(rechargeNum) == -1 ? 'option-box-checked' : '')" style="text-align: left;">
							<el-input-number v-model="rechargeNum" style="width:80%;" :min="1"
								class="recharge-num-input-20220709" :controls="false"></el-input-number>
							<font class="matter-span">{{$t('app.week')}}</font>
							<div v-if="rechargeNums.indexOf(rechargeNum) == -1" class="corner-mark-div"></div>
						</div>
					</el-col>
				</el-row>
			</div>
		</div>
		
		<div class="recharge-num-div">
			<div class="project-left-div" style="padding-top:5px;">
				<!-- <i class="fa fa-truck" aria-hidden="true"></i> -->
				{{$t('vip.payment.amount')}}:
			</div>
			<div class="project-right-div" style="color: #409EFF;">
				<font size="5">{{ rechargeNum * 20 * keywordIds.length}}</font> {{$t('vip.credit.name')}}
			</div>
		</div>
		
		<div class="recharge-type-div">
			<div class="project-left-div" style="padding-top:5px;">
				<!-- <i class="fa fa-truck" aria-hidden="true"></i> -->
				{{$t('vip.payment.name')}}:
			</div>
			<div class="project-right-div">
				<el-row :gutter="20">
					<el-col :span="4" v-for="item in 1" :key="item">
						<div class="option-box" :class="'option-box ' + (rechargeType==item ? 'option-box-checked' : '')" @click="rechargeType=item">
							{{$t('vip.credit.consume')}}
							<div v-if="rechargeType==item" class="corner-mark-div"></div>
						</div>
					</el-col>
				</el-row>
			</div>
		</div>

		<div class="recharge-info-div">
			<div class="project-left-div" style="padding-top:5px;">
				<!-- <i class="fa fa-truck" aria-hidden="true"></i> -->
				{{$t('vip.payment.remark')}}:
			</div>
			<div class="project-right-div">
				<el-tag v-for="(item,index) in keywordTitles" :key="item.index" style="margin:5px">
					{{ item }}
				</el-tag>
			</div>
		</div>

		<div class="bottom-div">
			<el-button @click="recharge(null)" type="primary" 
				style="width: 200px;" round>{{$t('app.confirm.ok')}}</el-button>
		</div>
	</div>
</template>

<script>
import { api_keyword_keywordTrackingExpirationTimeDelay } from '@/components/api/asinKeyword.js'
import { api_renewal_monitoring2 } from "@/components/api/keywordsMonitoring2";

export default {
	name: 'copySub',
	inject: ['F_alertMsg','F_windowLoading','F_getErrMSg','LOGINUSER','F_LOGIN'],
	data() {return {
		loginUser : this.LOGINUSER,
		rechargeNums : [1,5,10,20,50,100],
		rechargeNum : 5,
		rechargeType : 1,
		loading : false
	}},
	props:{
		keywordIds : {
			required:true
		},
		keywordTitles: {
			required:true
		},
		type : {
			default : 'add_keyword_monitoring'
		}
	},
	created() {
	},
	methods:{
		recharge : function(this_){
			this_ = this_ || this
			if(this_.$data.loading){
				return
			}
			this_.$data.loading = true
			this_.$options.methods.switchRecharge(this_)(this_.keywordIds.join(","),this_.$data.rechargeNum).then(res => {
				this_.F_LOGIN()
				this_.$data.loading = false
				this_.$emit('succeed')
				this_.F_alertMsg('续期成功',2)
			}).catch(err => {
				this_.$data.loading = false
				this_.F_alertMsg(this_.F_getErrMSg(err,"续期失败"),4)
			})
			
		},
		switchRecharge : function(this_) {
			this_ = this_ || this
			let fun
			switch (this_.type) {
				case 'add_keyword_monitoring':{
					fun = api_keyword_keywordTrackingExpirationTimeDelay
					break;
				}
				case 'add_keyword_monitoring2':{
					fun = api_renewal_monitoring2
					break;
				}
			}
			return fun;
		}
	},
	watch: {
		rechargeNum  : {
			handler(val) {
				if(val == null || val == undefined) this.$data.rechargeNum = 1
			},
			deep: true,
		}
	},	
}
</script>

<style scoped>
.main-c-div{
}
.account-info-div{
	background-color: #EBEEF5;
	padding: 10px;
}
.matter-span{
	font-size:1.5rem;
	color: #409EFF;
	margin-bottom:5px;
}
.recharge-project-div{
	margin: 20px 0px;
	padding: 10px;
	display: flex;
}
.project-left-div{
	width: 85px;
}
.project-right-div{
	flex: 1;
}
.recharge-project-div .option-box{
	text-align: center;
	padding: 10px 0px;
	border: 1px solid #DCDFE6;
	position: relative;
	margin-bottom: 10px;
}
.recharge-project-div .option-box:hover{
	border: 1px solid #409EFF;
	cursor: pointer;
}
.recharge-project-div .option-box-checked{
	border: 1px solid #409EFF;
}
.corner-mark-div{
	position: absolute;
	right: 0;
	bottom: 0px;
	width: 0;
	height: 0;
	border-style: solid;
	border-width: 0 0 20px 20px;
	border-color: transparent transparent #409EFF transparent;
}
.recharge-num-div{
	display: flex;
	padding: 10px;
}
.recharge-type-div{
	margin-top: 20px;
	display: flex;
	padding: 10px;
}
.recharge-type-div .option-box{
	text-align: center;
	padding: 10px 0px;
	border: 1px solid #DCDFE6;
	position: relative;
	margin-bottom: 10px;
	cursor: pointer;
}
.recharge-type-div .option-box-checked{
	border: 1px solid #409EFF;
}
.recharge-info-div{
	margin-top: 20px;
	display: flex;
	padding: 10px;
}
.recharge-info-div .project-right-div{
	border: 1px solid #DCDFE6;
	padding: 10px 5px;
	border-radius: 5px;
}
.bottom-div{
	padding-top: 20px;
	text-align: center;
	border-top: 1px solid #E4E7ED;
}
</style>
<style>
.recharge-num-input-20220709 input{
	border: 0px;
	height: 55px;
	font-size: 1.5rem;
	text-align: right;
}
</style>